import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Flex } from '../Box/Box';
import Text from '../Text/Text';

const Label = styled(Flex).attrs({
  m: '5px 20px 0 0',
  justify: 'flex-end',
  align: 'center'
})`
  flex-basis: 191px;
  flex-shrink: 0;
`;

const Value = styled(Text).attrs({
  spacing: '1px',
  lineHeight: '22px'
})`
  display: block;
  text-transform: uppercase;
`;

const Description = styled(Value).attrs({
  color: '#737373',
  size: '13px',
  lineHeight: '14px'
})`
  margin-top: 5px;
`;

const TableRow = ({ item }) => {
  if (!item.value) return null;

  return (
    <Flex align="flex-start" mb="10px">
      <Label>
        <Text color="#555" font="caption" size="13px" whiteSpace="nowrap">
          {item.label}
        </Text>
      </Label>

      <Box>
        <Value>{item.value}</Value>
        {item.description && <Description>{item.description}</Description>}
      </Box>
    </Flex>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired
};

const TableContent = ({ items }) => {
  return (
    <Box className="TableContentWrapper">
      {items.map((item, id) => <TableRow item={item} key={id} />)}
    </Box>
  );
};

TableContent.propTypes = {
  items: PropTypes.array.isRequired
};

export default TableContent;



// WEBPACK FOOTER //
// ./src/components/units/TableContent/TableContent.js